function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { isComponent } from "@brandwatch/axiom-utils";
import Icon from "../Icon/Icon";
import Link from "../Typography/Link";
import Tooltip from "../Tooltip/Tooltip";
import TooltipContent from "../Tooltip/TooltipContent";
import TooltipContext, { TooltipContextRef } from "../Tooltip/TooltipContext";
import TooltipSource from "../Tooltip/TooltipSource";
import TooltipTarget from "../Tooltip/TooltipTarget";
export const TextInputIconWrapperRef = "TextInputIconWrapper";
export default class TextInputIconWrapper extends Component {
  render() {
    const {
      align,
      onClick,
      tooltip,
      children,
      tooltipColor,
      ...rest
    } = this.props;
    const className = classnames("ax-input__icon", {
      [`ax-input__icon--align-${align}`]: align
    });
    const icon = tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      isVisible: true
    }, /*#__PURE__*/React.createElement(TooltipTarget, null, children), /*#__PURE__*/React.createElement(TooltipSource, {
      width: "auto"
    }, isComponent(tooltip, TooltipContextRef) ? tooltip : /*#__PURE__*/React.createElement(TooltipContext, {
      color: tooltipColor
    }, /*#__PURE__*/React.createElement(TooltipContent, {
      size: "tiny"
    }, tooltip)))) : children;
    return /*#__PURE__*/React.createElement("span", {
      className: className
    }, onClick ? /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
      onClick: onClick,
      style: "subtle"
    }), icon) : icon);
  }

}

_defineProperty(TextInputIconWrapper, "defaultProps", {
  align: "right",
  tooltipColor: "carbon"
});

_defineProperty(TextInputIconWrapper, "typeRef", TextInputIconWrapperRef);